// extracted by mini-css-extract-plugin
export default {"menuLink":"Dashboard_menuLink__jtMIO","profileMenuLinks":"Dashboard_profileMenuLinks__i2q06","headerIconLinks":"Dashboard_headerIconLinks__zRwOo"};